/* globals autosize */

import React, { Component, createRef } from 'react';
import { connect } from 'react-redux';
import { Button } from 'ui';
import { updateEvent } from 'actions/inPersonTraining/eventOverview';
import Error from 'components/InPersonTraining/shared/Error';
import { Text, TEXT_VARIANTS } from 'ui/Typography';

class EditForm extends Component {
  state = {
    loading: false,
    name: this.props.event.name,
    description: this.props.event.description,
    error: null,
  };

  descriptionInputRef = createRef();

  componentDidMount() {
    if (this.descriptionInputRef.current) {
      autosize(this.descriptionInputRef.current);
    }
  }

  get isValid() {
    return !!this.state.name;
  }

  handleSubmit = e => {
    e.preventDefault();
    const attrs = {
      name: this.state.name,
      description: this.state.description,
    };
    this.setState({ loading: true }, () => {
      this.props
        .updateEvent(attrs)
        .then(this.props.onDismiss)
        .catch(error => {
          this.setState({ loading: false, error: error.responseJSON });
        });
    });
  };

  handleChange = e => {
    this.setState({ [e.target.name]: e.target.value });
  };

  render() {
    const { onDismiss } = this.props;
    const { name, description, loading, error } = this.state;
    return (
      <form
        onSubmit={this.handleSubmit}
        className="EventOverviewHeader-editForm"
      >
        <label htmlFor="name">
          <Text variant={TEXT_VARIANTS.INSTRUX_SMALL_SEMIBOLD}>
            {t('common.name')} *
          </Text>
        </label>
        <input
          className="NewInput NewInput--white NewInput--fw mb-8"
          id="name"
          name="name"
          value={name}
          onChange={this.handleChange}
          maxLength={255}
          required
        />
        <label htmlFor="description">
          <Text variant={TEXT_VARIANTS.INSTRUX_SMALL_SEMIBOLD}>
            {t('common.description')}
          </Text>
        </label>
        <textarea
          className="Textarea w-fill mb-8"
          id="description"
          name="description"
          value={description}
          onChange={this.handleChange}
          ref={this.descriptionInputRef}
        />
        {error !== null && <Error {...error} />}
        <div className="d-f jc-sb mt-16">
          <button type="button" className="u-linkBtn" onClick={onDismiss}>
            {t('common.cancel')}
          </button>
          <Button
            submit
            customColor
            tall
            loading={loading}
            disabled={!this.isValid}
          >
            {t('in_person_training.event_overview.edit_form.submit_button')}
          </Button>
        </div>
      </form>
    );
  }
}

const mapDispatchToProps = {
  updateEvent,
};

const mapStateToProps = state => ({
  event: state.event,
});

export default connect(mapStateToProps, mapDispatchToProps)(EditForm);
